import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { tieneAcceso } from "../constants/Accesos";

export function ProtectedRoute({ children, allowedEmails }) {
  const { user, loading } = useAuth();

  if (loading) return <h1 className="text-4xl text-center">Cargando</h1>;

  if (!user) return <Navigate to="/login" />;

  if (allowedEmails && !tieneAcceso(user.email, allowedEmails)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
